import { useCallback, useEffect, useMemo, useState } from 'react';
import humps from 'humps';

import { getUserActivitySummaryApi } from '../_apis_/authApi.js/userActivityApi';
import { buildFrequentlyUsedModules, parseUserActivitySummary } from '../utils/frequentlyUsedModules';

export default function useFrequentlyUsedModules({
  userId,
  enabled = true,
  limit = 5,
}) {
  const [allRecords, setAllRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchModules = useCallback(async () => {
    if (!userId || !enabled) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getUserActivitySummaryApi(userId);
      const camelized = humps.camelizeKeys(response?.data ?? response);
      setAllRecords(parseUserActivitySummary(camelized));
    } catch (err) {
      console.error('Failed to load frequently used modules:', err);
      setError(err);
      setAllRecords([]);
    } finally {
      setLoading(false);
    }
  }, [userId, enabled]);

  useEffect(() => {
    fetchModules();
  }, [fetchModules]);

  const modules = useMemo(
    () => buildFrequentlyUsedModules(allRecords, limit),
    [allRecords, limit]
  );

  return { modules, loading, error, refetch: fetchModules };
}
